module.exports = __webpack_public_path__ + "static/img/rank_215.15b1fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_215.png
// module id = 7MXm
// module chunks = 0